// extracted by mini-css-extract-plugin
export default {"container":"error_container__I9irt","buttonWrapper":"error_buttonWrapper__aR2X+"};